import React, { useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";

const Calender = ({ value, handleValueChange }) => {
  return (
    <div className="w-auto">
      <Datepicker
        placeholder={"Check In - Check Out"}
        primaryColor={"yellow"}
        value={value}
        onChange={handleValueChange}
        // className="Check In - Check Out"
      />
    </div>
  );
};

export default Calender;
